(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTIONS = ['tnr-cart-drawer', 'tnr-cart-page'];
    const drawer = () => document.getElementById('TnrCartDrawer');
    const panel = () => drawer()?.querySelector('.tnr-drawer__panel');
    let lastTrigger = null;

    const routes = () => window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change' };

    /* ---------- glass refraction (Chromium only) ---------- */

    // Edges bend the page behind like a lens: a displacement map that is neutral in the middle and
    // ramps up within `depth` px of each edge; red/green/blue are displaced slightly differently (dispersion).
    const supportsRefraction = () =>
      !!navigator.userAgentData?.brands?.some((b) => /Chromium/i.test(b.brand)) &&
      !window.matchMedia('(prefers-reduced-transparency: reduce)').matches;

    const buildGlass = () => {
      const el = panel();
      const filter = document.getElementById('TnrGlassFilter');
      if (!el || !filter || !supportsRefraction()) return;
      const w = Math.round(el.offsetWidth);
      const h = Math.round(el.offsetHeight);
      if (!w || !h) return;
      const style = getComputedStyle(el);
      const depth = parseFloat(style.getPropertyValue('--tnr-glass-depth')) || 20;
      const refraction = parseFloat(style.getPropertyValue('--tnr-glass-refraction')) || 0.8;
      const dispersion = parseFloat(style.getPropertyValue('--tnr-glass-dispersion')) || 0;
      const frost = (parseFloat(style.getPropertyValue('--tnr-glass-frost')) || 2) / 2;
      if (filter.dataset.size === `${w}x${h}x${depth}`) return;
      filter.dataset.size = `${w}x${h}x${depth}`;

      // Each edge samples from further inside the glass (never outside it, which would show as a dark line).
      // Left/top push values above neutral (128), right/bottom below it.
      const ramp = (id, x1, y1, x2, y2, channel, edge) => {
        const c = (v) => (channel === 'r' ? `rgb(${v},128,128)` : `rgb(128,${v},128)`);
        const mid = Math.round(128 + (edge - 128) * 0.25);
        return `<linearGradient id="${id}" x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}">
          <stop offset="0" stop-color="${c(edge)}"/><stop offset="0.6" stop-color="${c(mid)}"/><stop offset="1" stop-color="${c(128)}"/>
        </linearGradient>`;
      };
      const map = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
        <defs>
          ${ramp('l', 0, 0, 1, 0, 'r', 255)}${ramp('r', 1, 0, 0, 0, 'r', 0)}
          ${ramp('t', 0, 0, 0, 1, 'g', 255)}${ramp('b', 0, 1, 0, 0, 'g', 0)}
        </defs>
        <rect width="${w}" height="${h}" fill="rgb(128,128,128)"/>
        <rect width="${depth}" height="${h}" fill="url(#l)"/>
        <rect x="${w - depth}" width="${depth}" height="${h}" fill="url(#r)"/>
        <rect width="${w}" height="${depth}" fill="url(#t)" opacity="0.5"/>
        <rect y="${h - depth}" width="${w}" height="${depth}" fill="url(#b)" opacity="0.5"/>
      </svg>`;
      const scale = depth * refraction;
      const spread = 1 + dispersion * 0.12;
      // Each colour channel is displaced by a slightly different amount, then the three are added back together.
      // (Chrome drops the whole panel if these are combined with feBlend "screen", so arithmetic compositing is used.)
      const channel = (name, s, matrix) => `
        <feDisplacementMap in="frost" in2="map" scale="${s}" xChannelSelector="R" yChannelSelector="G" result="d${name}"/>
        <feColorMatrix in="d${name}" type="matrix" values="${matrix}" result="c${name}"/>`;
      filter.setAttribute('width', w);
      filter.setAttribute('height', h);
      filter.setAttribute('filterUnits', 'userSpaceOnUse');
      filter.innerHTML = `
        <feImage href="data:image/svg+xml,${encodeURIComponent(map)}" x="0" y="0" width="${w}" height="${h}" preserveAspectRatio="none" result="map"/>
        <feGaussianBlur in="SourceGraphic" stdDeviation="${frost}" result="frost"/>
        ${channel('r', scale * spread, '1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0')}
        ${channel('g', scale, '0 0 0 0 0  0 1 0 0 0  0 0 0 0 0  0 0 0 1 0')}
        ${channel('b', scale / spread, '0 0 0 0 0  0 0 0 0 0  0 0 1 0 0  0 0 0 1 0')}
        <feComposite in="cr" in2="cg" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="crg"/>
        <feComposite in="crg" in2="cb" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="rgb"/>
        <feColorMatrix in="rgb" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0 1"/>`;
      el.classList.add('tnr-glass--refract');
    };

    window.addEventListener('resize', () => {
      if (drawer()?.classList.contains('is-open')) buildGlass();
    });

    /* ---------- open / close ---------- */

    const open = (trigger) => {
      const el = drawer();
      if (!el || el.classList.contains('is-open')) return;
      lastTrigger = trigger || document.activeElement;
      el.hidden = false;
      document.documentElement.classList.add('tnr-drawer-open');
      buildGlass();
      requestAnimationFrame(() => {
        el.classList.add('is-open');
        panel()?.focus({ preventScroll: true });
      });
    };

    const close = () => {
      const el = drawer();
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('tnr-drawer-open');
      const done = () => {
        if (!el.classList.contains('is-open')) el.hidden = true;
      };
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) done();
      else panel()?.addEventListener('transitionend', done, { once: true });
      lastTrigger?.focus?.({ preventScroll: true });
    };

    /* ---------- re-render after a cart change ---------- */

    const render = (sections) => {
      if (!sections) return;
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tnr-cart-contents]');

      const fresh = sections['tnr-cart-drawer'] && parse(sections['tnr-cart-drawer']);
      const current = drawer()?.querySelector('[data-tnr-cart-contents]');
      if (fresh && current) current.replaceWith(fresh);

      const freshPage = sections['tnr-cart-page'] && parse(sections['tnr-cart-page']);
      const currentPage = document.querySelector('[data-tnr-cart-page] [data-tnr-cart-contents]');
      if (freshPage && currentPage) currentPage.replaceWith(freshPage);

      const count = (fresh || freshPage)?.dataset.count;
      const counter = document.getElementById('TnrCartCount');
      if (count !== undefined && counter) counter.textContent = count;
    };

    const announce = (cart) => {
      const ids = (cart?.items || []).map((item) => String(item.variant_id));
      document.dispatchEvent(new CustomEvent('tnr:cart:updated', { detail: { variantIds: ids } }));
    };

    const post = async (url, body) => {
      const response = await fetch(`${url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname }),
      });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message || 'Error');
      return json;
    };

    /* ---------- events ---------- */

    document.addEventListener('click', async (event) => {
      // Header "cart[n]" opens the drawer (on the cart page itself it just stays put).
      const cartLink = event.target.closest('#TnrCartLink');
      if (cartLink && drawer()) {
        event.preventDefault();
        if (!document.querySelector('[data-tnr-cart-page]')) open(cartLink);
        return;
      }

      // X, the invisible overlay, or anywhere else outside the panel closes the drawer.
      const openDrawer = drawer();
      if (
        event.target.closest('[data-tnr-cart-close]') ||
        (openDrawer?.classList.contains('is-open') && !event.target.closest('.tnr-drawer__panel'))
      ) {
        close();
        return;
      }

      // Empty state "< shop all": just close if we're already on a grid.
      const keepShopping = event.target.closest('[data-tnr-cart-continue]');
      if (keepShopping && drawer()?.contains(keepShopping) && document.querySelector('.tnr-products')) {
        event.preventDefault();
        close();
        return;
      }

      const remove = event.target.closest('[data-tnr-remove]');
      if (remove) {
        event.preventDefault();
        if (remove.getAttribute('aria-busy') === 'true') return;
        remove.setAttribute('aria-busy', 'true');
        try {
          const cart = await post(routes().cart_change_url, { id: remove.dataset.tnrRemove, quantity: 0 });
          render(cart.sections);
          announce(cart);
          if (drawer()?.classList.contains('is-open')) panel()?.focus({ preventScroll: true });
        } catch (error) {
          remove.removeAttribute('aria-busy');
          window.location.reload();
        }
      }
    });

    // Product page "+ ADD TO CART": add without leaving the page, then open the drawer.
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.tnr-pdp__form');
      if (!form || !drawer()) return;
      event.preventDefault();

      const button = form.querySelector('[data-tnr-add]');
      const error = form.querySelector('[data-tnr-add-error]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      if (error) error.textContent = '';

      try {
        const item = await post(routes().cart_add_url, { id: form.querySelector('[name="id"]').value, quantity: 1 });
        render(item.sections);
        document.dispatchEvent(
          new CustomEvent('tnr:cart:updated', { detail: { added: String(item.variant_id) } })
        );
        open(button);
      } catch (e) {
        if (error) error.textContent = e.message;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });

    // Keep the product page button in sync: "IN CART" after adding, back to "+ ADD TO CART" after removing.
    document.addEventListener('tnr:cart:updated', (event) => {
      document.querySelectorAll('[data-tnr-in-cart]').forEach((link) => {
        const id = link.dataset.variantId;
        const { added, variantIds } = event.detail || {};
        let inCart = !link.hidden;
        if (added === id) inCart = true;
        if (variantIds) inCart = variantIds.includes(id);
        link.hidden = !inCart;
        const add = link.closest('form')?.querySelector('[data-tnr-add]');
        if (add) add.hidden = inCart;
      });
    });

    // Escape closes; Tab stays inside the open drawer.
    document.addEventListener('keydown', (event) => {
      const el = drawer();
      if (!el || !el.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel().querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(
        (node) => !node.closest('[hidden]') && node.offsetParent !== null
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel())) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 240;
    const STAGGER = 18;
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const cancelAll = (elements) => elements.forEach((el) => el.getAnimations().forEach((a) => a.cancel()));

    /**
     * Opens or closes the "sizing" panel (aria-controls): the panel grows to its height,
     * then each size (and "clear all") fades in one after another.
     */
    const setOpen = (toggle, open) => {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      const grow = panel;
      // "clear all" only comes along when a filter is actually on.
      const extras = [...(toggle.parentElement?.querySelectorAll('.tnr-header__clear[data-active="true"]') || [])];
      const items = [...extras, ...panel.querySelectorAll('li')];

      toggle.setAttribute('aria-expanded', String(open));
      try {
        sessionStorage.setItem('tnr-sizing', open ? 'open' : 'closed');
      } catch (e) {}
      const icon = toggle.querySelector('[data-tnr-toggle-icon]');
      if (icon) icon.textContent = open ? '[-]' : '[+]';

      cancelAll([grow, ...items]);
      const setHidden = (hidden) => {
        panel.hidden = hidden;
        extras.forEach((el) => (el.hidden = hidden));
      };

      const from = grow.offsetHeight;
      setHidden(false);
      const openHeight = grow.offsetHeight;
      setHidden(true);
      const closedHeight = grow.offsetHeight;
      setHidden(!open);

      if (reduceMotion()) return;

      const heightFrames = (a, b) => [
        { height: `${a}px`, overflow: 'hidden' },
        { height: `${b}px`, overflow: 'hidden' },
      ];

      if (open) {
        grow.animate(heightFrames(from, openHeight), { duration: DURATION, easing: 'ease-out' });
        items.forEach((el, i) =>
          el.animate([{ opacity: 0 }, { opacity: 1 }], {
            duration: DURATION,
            delay: i * STAGGER,
            easing: 'ease-out',
            fill: 'backwards',
          })
        );
        return;
      }

      // Closing: keep items visible while they fade and the height shrinks, then hide.
      setHidden(false);
      items.forEach((el) => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DURATION / 2, fill: 'forwards' }));
      grow
        .animate(heightFrames(from, closedHeight), { duration: DURATION, easing: 'ease-in', fill: 'forwards' })
        .finished.then(() => {
          setHidden(true);
          cancelAll([grow, ...items]);
        })
        .catch(() => {});
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-tnr-toggle]');
      if (!toggle) return;
      setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    });

    /*
     * Filters are read from the page address, so they work whether or not Shopify's
     * Search & Discovery filters are set up:
     *   sizes       filter.v.option.size=<values> + tnr_size=<picked size> (ranges share values,
     *               e.g. 28 is in both 26-28 and 28-30, so tnr_size says exactly which was picked)
     *   categories  tnr_cat=<collection handle>, shown on shop all (several can be picked)
     * Picked items show in full black, links toggle them on/off, and the grid is narrowed
     * to matching pieces. Shopify narrows it itself once its Size filter is set up.
     */
    const params = () => new URLSearchParams(window.location.search);

    const syncSizes = () => {
      const panel = document.querySelector('.tnr-sizes[data-param]');
      if (!panel) return { selected: [], native: false };
      const param = panel.dataset.param || 'filter.v.option.size';
      const selected = params().getAll(param);
      const links = [...panel.querySelectorAll('a[data-tnr-size-key]')];
      const valuesOf = (link) => link.dataset.tnrSizeValues.split('|~~|').filter(Boolean);
      let keys = params().getAll('tnr_size');
      if (!keys.length && selected.length) {
        keys = links.filter((link) => valuesOf(link).some((v) => selected.includes(v))).map((l) => l.dataset.tnrSizeKey);
      }

      const urlFor = (nextKeys) => {
        const url = new URL(window.location.href);
        url.searchParams.delete(param);
        url.searchParams.delete('tnr_size');
        url.searchParams.delete('page');
        const values = new Set();
        links
          .filter((link) => nextKeys.includes(link.dataset.tnrSizeKey))
          .forEach((link) => valuesOf(link).forEach((v) => values.add(v)));
        values.forEach((v) => url.searchParams.append(param, v));
        nextKeys.forEach((k) => url.searchParams.append('tnr_size', k));
        return url.pathname + url.search;
      };

      // Links toggle from the current selection and stay on this page (homepage included).
      links.forEach((link) => {
        const key = link.dataset.tnrSizeKey;
        const on = keys.includes(key);
        link.classList.toggle('is-active', on);
        if (on) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        link.href = urlFor(on ? keys.filter((k) => k !== key) : [...keys, key]);
      });

      if (keys.length) {
        // Show the selection: open the panel straight away (no animation).
        const toggle = document.querySelector(`[aria-controls="${panel.id}"]`);
        if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
          toggle.setAttribute('aria-expanded', 'true');
          const icon = toggle.querySelector('[data-tnr-toggle-icon]');
          if (icon) icon.textContent = '[-]';
          panel.hidden = false;
        }
      }
      return { selected: keys.length ? selected : [], native: panel.dataset.native === 'true' };
    };

    const syncCategories = () => {
      const links = [...document.querySelectorAll('.tnr-header__category-list a[data-tnr-cat]')];
      if (!links.length) return { cats: [], onAll: false };
      const allLink = links.find((l) => l.dataset.tnrCat === 'all');
      const shopAllPath = allLink ? new URL(allLink.href, window.location.href).pathname : '/collections/all';
      // The homepage is the shop-all grid too: filters picked there stay there.
      const onHome = window.location.pathname === '/';
      const allPath = onHome ? '/' : shopAllPath;
      const onAll = onHome || window.location.pathname === shopAllPath;
      let cats = params().getAll('tnr_cat');
      // On a single category page (/collections/t-shirts), that category counts as picked.
      // (Compare against each link's own collection page, not its href — the script rewrites hrefs.)
      const pageLink = links.find(
        (l) =>
          l.dataset.tnrCat !== 'all' &&
          new URL(l.dataset.tnrCatPage || l.href, window.location.href).pathname === window.location.pathname
      );
      if (!cats.length && pageLink) cats = [pageLink.dataset.tnrCat];

      const urlFor = (nextCats) => {
        const url = new URL(window.location.href);
        url.pathname = allPath;
        url.searchParams.delete('tnr_cat');
        url.searchParams.delete('page');
        nextCats.forEach((c) => url.searchParams.append('tnr_cat', c));
        return url.pathname + url.search;
      };

      links.forEach((link) => {
        const cat = link.dataset.tnrCat;
        let on;
        if (cat === 'all') {
          on = !cats.length && (onAll || link.classList.contains('is-active'));
          link.href = urlFor([]);
        } else {
          on = cats.includes(cat);
          link.href = urlFor(on ? cats.filter((c) => c !== cat) : [...cats, cat]);
        }
        link.classList.toggle('is-active', on);
        if (on) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
      return { cats, onAll, allPath };
    };

    const applyFilters = () => {
      const sizes = syncSizes();
      const categories = syncCategories();
      const grid = document.querySelector('.tnr-products');

      // Narrow the grid. Cards are removed rather than hidden, so the "start each row after
      // the logo column" layout rule keeps counting correctly.
      if (grid) {
        const sizeFilter = sizes.selected.length && !sizes.native ? sizes.selected : null;
        const catFilter = categories.onAll && categories.cats.length ? categories.cats : null;
        if (sizeFilter || catFilter) {
          let shown = 0;
          grid.querySelectorAll('.tnr-card[data-tnr-size]').forEach((card) => {
            const sizeOk = !sizeFilter || sizeFilter.includes(card.dataset.tnrSize);
            const cardCats = (card.dataset.tnrCats || '').split(' ');
            const catOk = !catFilter || catFilter.some((c) => cardCats.includes(c));
            if (sizeOk && catOk) shown += 1;
            else card.remove();
          });
          if (!shown && !grid.querySelector('.tnr-products__empty')) {
            const empty = document.createElement('p');
            empty.className = 'tnr-products__empty';
            empty.textContent = grid.dataset.emptyText || '';
            grid.prepend(empty);
          }
        }
      }

      // "tags n' rags" (desktop) goes home but keeps the current filters.
      const home = document.querySelector('.tnr-header__name--link');
      if (home) {
        const url = new URL('/', window.location.href);
        const current = params();
        current.forEach((value, name) => {
          if (name === 'tnr_size' || name === 'sort_by' || name.startsWith('filter.')) url.searchParams.append(name, value);
        });
        categories.cats.forEach((c) => url.searchParams.append('tnr_cat', c));
        home.href = url.pathname + url.search;
      }

      // "clear all": shown while any size or category is picked; goes back to the unfiltered grid.
      const clear = document.querySelector('[data-tnr-clear]');
      if (clear) {
        const anything = sizes.selected.length > 0 || (categories.onAll && categories.cats.length > 0);
        if (anything) {
          clear.dataset.active = 'true';
          const url = new URL(window.location.href);
          url.pathname = categories.allPath || url.pathname;
          url.search = '';
          const sort = params().get('sort_by');
          if (sort) url.searchParams.set('sort_by', sort);
          clear.href = url.pathname + url.search;
        } else {
          delete clear.dataset.active;
        }
        const panel = document.querySelector('.tnr-sizes[data-param]');
        clear.hidden = !(anything && panel && !panel.hidden);
      }
    };

    /*
     * Picking a size or "clear all" on the same page: fade the grid, fetch the new results,
     * swap them in and fade back — no full reload, and the sizing panel stays open.
     */
    const FILTER_FADE = 180;
    let filterRequest = 0;
    // The address whose results are on screen (so a stray "back" to the same page does nothing).
    let shownFilters = window.location.pathname + window.location.search;

    const swapFilters = async (url, push = true) => {
      const main = document.getElementById('MainContent');
      const panel = document.querySelector('.tnr-sizes[data-param]');
      if (!main || !panel) {
        window.location.href = url;
        return;
      }
      const request = ++filterRequest;
      const reduce = reduceMotion();
      const fadeOut = reduce ? null : main.animate([{ opacity: 1 }, { opacity: 0 }], { duration: FILTER_FADE, fill: 'forwards' });

      try {
        const [html] = await Promise.all([fetch(url).then((r) => r.text()), fadeOut?.finished]);
        if (request !== filterRequest) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextMain = doc.getElementById('MainContent');
        const nextPanel = doc.querySelector('.tnr-sizes[data-param]');
        const nextClear = doc.querySelector('[data-tnr-clear]');
        if (!nextMain || !nextPanel) throw new Error('missing');

        main.innerHTML = nextMain.innerHTML;
        panel.innerHTML = nextPanel.innerHTML;
        panel.dataset.native = nextPanel.dataset.native || '';
        if (!nextPanel.dataset.native) delete panel.dataset.native;

        const clear = document.querySelector('[data-tnr-clear]');
        if (clear && nextClear) {
          clear.href = nextClear.getAttribute('href');
          if (nextClear.dataset.active) clear.dataset.active = nextClear.dataset.active;
          else delete clear.dataset.active;
          clear.hidden = clear.dataset.active !== 'true';
        }

        if (push) window.history.pushState({ tnrFilters: true }, '', url);
        shownFilters = url;
        applyFilters();

        // Keep the panel open (the shopper hasn't closed it).
        const toggle = document.querySelector(`[aria-controls="${panel.id}"]`);
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          const icon = toggle.querySelector('[data-tnr-toggle-icon]');
          if (icon) icon.textContent = '[-]';
        }
        panel.hidden = false;

        main.getAnimations().forEach((a) => a.cancel());
        if (!reduce) main.animate([{ opacity: 0 }, { opacity: 1 }], { duration: FILTER_FADE * 1.5, easing: 'ease-out' });
      } catch (e) {
        window.location.href = url;
      }
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.tnr-sizes a[href], a[data-tnr-clear], .tnr-header__category-list a[data-tnr-cat]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
      const url = new URL(link.href, window.location.href);
      // Only swap in place when the link stays on this page (e.g. not homepage → shop all).
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      event.preventDefault();
      swapFilters(url.pathname + url.search);
    });

    window.addEventListener('popstate', () => {
      const url = window.location.pathname + window.location.search;
      if (url === shownFilters) return;
      if (document.querySelector('.tnr-sizes[data-param]')) swapFilters(url, false);
    });

    /*
     * Smart sticky header: hide while scrolling down, show on scroll up or near the top.
     * Also tells the page how much room the header takes (--tnr-sticky-offset) so the
     * product page's pinned info can sit below it.
     */
    const initSmartHeader = () => {
      const section = document.querySelector('.tnr-header')?.closest('.shopify-section');
      if (!section || section.closest('.tnr-peek')) return;
      // Product pages keep a normal, non-sticky header.
      if (document.querySelector('main[data-template="product"]')) return;
      const root = document.documentElement;
      const info = section.querySelector('.tnr-header__info');
      const desktop = window.matchMedia('(min-width: 1200px)');
      let lastY = window.scrollY;
      let offset = 0; // the header's `top`: 0 = fully shown, -height = fully scrolled away

      // Mobile: how much of the header's top (the logo) stays tucked away when it returns.
      const logoArea = () => {
        if (desktop.matches || !info) return 0;
        return Math.max(0, info.getBoundingClientRect().top - section.getBoundingClientRect().top - 12);
      };

      const apply = () => {
        const height = section.offsetHeight;
        const y = window.scrollY;
        // Near the very top the header is simply part of the page (logo included).
        const maxTop = y > height ? -logoArea() : 0;
        offset = Math.min(maxTop, Math.max(-height, offset));
        if (y <= 0) offset = 0;
        section.style.top = `${offset}px`;
        // How much header is on screen, so the product page's pinned info can sit below it.
        root.style.setProperty('--tnr-sticky-offset', `${Math.max(0, height + offset)}px`);
      };

      const update = () => {
        const y = window.scrollY;
        offset -= y - lastY; // move with the page, 1:1
        lastY = y;
        apply();
      };

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', apply);
      // Keyboard users tabbing into the header always see it (mouse clicks don't count).
      section.addEventListener('focusin', (event) => {
        if (!event.target.matches(':focus-visible')) return;
        offset = 0;
        apply();
      });
      apply();
    };
    initSmartHeader();

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFilters);
    else applyFilters();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const intro = document.getElementById('TnrIntro');
    if (!intro || !intro.classList.contains('is-active')) return;

    const DELAY = 400; // before the first letter starts
    const MAX_SHUFFLE = 1800; // whole shuffle, first letter start → last letter done
    const STEP = 32; // ms per alphabet step
    const HOLD = 800; // finished text sits before fading
    const FADE = 500;
    const ALPHABET = 'abcdefghijklmnopqrstuvwxyz';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const textEl = intro.querySelector('.tnr-intro__text');
    const text = intro.dataset.text || textEl.textContent;

    // One span per character; letters a–z shuffle, everything else (spaces, ’) just appears.
    const chars = [...text].map((ch, index) => {
      const span = document.createElement('span');
      span.className = 'tnr-intro__char is-waiting';
      span.textContent = ch;
      const target = ALPHABET.indexOf(ch.toLowerCase());
      return { span, ch, index, target, upper: ch !== ch.toLowerCase() };
    });
    textEl.replaceChildren(...chars.map((c) => c.span));
    intro.classList.add('is-ready');

    // Stagger letters as much as possible while every letter still lands within MAX_SHUFFLE.
    let stagger = 80;
    chars.forEach(({ index, target }) => {
      if (index > 0) stagger = Math.min(stagger, (MAX_SHUFFLE - Math.max(target, 0) * STEP) / index);
    });
    stagger = Math.max(stagger, 0);

    let start = null;
    let frame = null;
    let ending = false;

    const showAll = () => {
      chars.forEach((c) => {
        c.span.textContent = c.ch;
        c.span.classList.remove('is-waiting');
      });
    };

    const finish = () => {
      if (ending) return;
      ending = true;
      cancelAnimationFrame(frame);
      showAll();
      const done = () => {
        intro.remove();
        document.documentElement.classList.remove('tnr-intro-open');
        window.removeEventListener('pointerdown', skip, true);
        window.removeEventListener('keydown', skip, true);
      };
      if (reduceMotion) {
        intro.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished.then(done, done);
        return;
      }
      intro.animate([{ opacity: 1 }, { opacity: 0 }], { duration: FADE, easing: 'ease-in-out', fill: 'forwards' })
        .finished.then(done, done);
    };

    let holdTimer = null;
    const skip = () => {
      clearTimeout(holdTimer);
      finish();
    };
    window.addEventListener('pointerdown', skip, true);
    window.addEventListener('keydown', skip, true);

    if (reduceMotion) {
      showAll();
      holdTimer = setTimeout(finish, HOLD);
      return;
    }

    const tick = (now) => {
      if (start === null) start = now + DELAY;
      const elapsed = now - start;
      let allDone = true;

      chars.forEach((c) => {
        const t = elapsed - c.index * stagger;
        if (t < 0) {
          allDone = false;
          return;
        }
        c.span.classList.remove('is-waiting');
        if (c.target < 0) return; // space or punctuation
        const step = Math.min(c.target, Math.floor(t / STEP));
        const letter = ALPHABET[step];
        c.span.textContent = c.upper ? letter.toUpperCase() : letter;
        if (step < c.target) allDone = false;
      });

      if (allDone) {
        holdTimer = setTimeout(finish, HOLD);
        return;
      }
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'tnr-popup';
    const popup = () => document.getElementById('TnrPopup');

    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY) || 'null');
      } catch (e) {
        return null;
      }
    };
    const write = (value) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(value));
      } catch (e) {}
    };

    // Seen it recently, or already signed up: stay away.
    const shouldShow = (el) => {
      if (el.dataset.off === 'true') return false;
      const state = read();
      if (!state) return true;
      if (state.subscribed) return false;
      const days = parseFloat(el.dataset.days) || 30;
      return Date.now() - (state.dismissed || 0) > days * 86400000;
    };

    const open = () => {
      const el = popup();
      if (!el || el.classList.contains('is-open')) return;
      el.hidden = false;
      void el.offsetHeight; // start from the off-screen position so it slides up
      el.classList.add('is-open');
    };

    const close = (remember = true) => {
      const el = popup();
      if (!el || el.hidden) return;
      if (remember && !el.classList.contains('is-done')) write({ ...(read() || {}), dismissed: Date.now() });
      el.classList.remove('is-open');
      const done = () => {
        if (!el.classList.contains('is-open')) el.hidden = true;
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else el.addEventListener('transitionend', done, { once: true });
    };

    const showDone = (el) => {
      el.classList.add('is-done');
      el.querySelector('[data-tnr-popup-text]').hidden = true;
      const doneText = el.querySelector('[data-tnr-popup-done]');
      doneText.hidden = false;
      doneText.setAttribute('role', 'status');
      el.querySelector('[data-tnr-popup-error]').hidden = true;
      el.querySelector('input[type="email"]').readOnly = true;
      el.querySelector('[data-tnr-popup-submit]').hidden = true;
      el.querySelector('[data-tnr-popup-close-main]').hidden = false;
      el.querySelector('[data-tnr-popup-dismiss-label]').hidden = true;
      el.querySelector('[data-tnr-popup-thanks-label]').hidden = false;
      write({ subscribed: true });
    };

    // Shopify's cookie banner, while it's on screen.
    const cookieBanner = () => {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner || !banner.isConnected) return false;
      const style = getComputedStyle(banner);
      return style.display !== 'none' && style.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
    };

    // Wait for the intro, the cookie banner and the cart to be out of the way, then the set delay.
    const schedule = (el) => {
      const delay = (parseFloat(el.dataset.delay) || 0) * 1000;
      const busy = () =>
        document.getElementById('TnrIntro') ||
        document.documentElement.classList.contains('tnr-drawer-open') ||
        cookieBanner();
      const wait = () => {
        if (busy()) {
          setTimeout(wait, 400);
          return;
        }
        setTimeout(() => {
          if (busy()) wait();
          else open();
        }, delay);
      };
      wait();
    };

    // Check the email here first; a good one is sent the normal way (page reloads).
    const PENDING = 'tnr-popup-pending';
    const onSubmit = (event) => {
      const el = popup();
      const form = event.currentTarget;
      const input = form.querySelector('input[type="email"]');
      const error = el.querySelector('[data-tnr-popup-error]');
      if (!input.value.trim() || !input.checkValidity()) {
        event.preventDefault();
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      error.hidden = true;
      input.removeAttribute('aria-invalid');
      el.querySelector('[data-tnr-popup-submit]').setAttribute('aria-busy', 'true');
      try {
        sessionStorage.setItem(PENDING, '1');
      } catch (e) {}
    };

    const init = () => {
      const el = popup();
      if (!el || el.dataset.ready) return;
      el.dataset.ready = 'true';

      el.querySelector('form')?.addEventListener('submit', onSubmit);
      el.querySelector('[data-tnr-popup-dismiss]')?.addEventListener('click', () => close());
      el.querySelector('[data-tnr-popup-close-main]')?.addEventListener('click', () => close());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && el.classList.contains('is-open')) close();
      });

      // Back from sending the pop-up's form: open straight away on "you're in!" or the error.
      // (The footer's form shares Shopify's result, so only react when this form was sent.)
      let pending = false;
      try {
        pending = sessionStorage.getItem(PENDING) === '1' || window.location.hash === '#TnrPopupForm';
        sessionStorage.removeItem(PENDING);
      } catch (e) {}
      const result = el.querySelector('[data-tnr-popup-result]')?.dataset.tnrPopupResult;
      if (pending && result === 'done') {
        showDone(el);
        open();
        return;
      }
      if (pending && result === 'error') {
        el.querySelector('[data-tnr-popup-error]').hidden = false;
        el.querySelector('input[type="email"]').setAttribute('aria-invalid', 'true');
        open();
        return;
      }
      if (shouldShow(el)) schedule(el);
    };

    init();

    // Theme editor: show it while the section is selected.
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.querySelector?.('#TnrPopup')) open();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target.querySelector?.('#TnrPopup')) close(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // "enter using password >" ⇄ "< sign up for updates": swap the two views and focus the field.
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tnr-password-switch]');
      if (!button) return;
      const root = button.closest('.tnr-password');
      const next = button.dataset.view === 'signup' ? 'enter' : 'signup';
      button.dataset.view = next;

      root.querySelectorAll('[data-tnr-password-view]').forEach((el) => {
        const show = el.dataset.tnrPasswordView === next;
        el.hidden = !show;
        if (show && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
        }
      });

      const field = root.querySelector(`[data-tnr-password-view="${next}"] input:not([type="hidden"])`);
      field?.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-product-grid"] && !Shopify.designMode) return;
  try {
    
  /*
   * Coming back to the grid puts the shopper where they were.
   * The grid saves its own place (the card nearest the top of the screen, or the card tapped)
   * whenever the shopper leaves, and puts that card back in the same spot on return, whether
   * by the phone's back arrow or the product page's "< back" (even after "next >").
   * The browser's own restore is switched off on the grid: it can run before the grid has
   * finished loading and land at the top.
   */
  (() => {
    const RETURN_KEY = 'tnr-grid-return'; // last grid a product was opened from (for "< back")
    const POS_KEY = 'tnr-grid-pos'; // saved place per grid address
    const BACK_FLAG = 'tnr-grid-back';
    const here = () => window.location.pathname + window.location.search;
    const cards = () => [...document.querySelectorAll('.tnr-products a[href]')];
    const read = (key) => {
      try {
        return JSON.parse(sessionStorage.getItem(key) || 'null');
      } catch (e) {
        return null;
      }
    };
    const write = (key, value) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    };

    if (!document.querySelector('.tnr-products') || document.querySelector('.tnr-peek')) return;
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

    let tapped = null;
    const place = (link) => {
      const anchor = link || cards().find((a) => a.getBoundingClientRect().bottom > 0);
      return {
        url: here(),
        y: window.scrollY,
        href: anchor ? anchor.getAttribute('href') : '',
        top: anchor ? anchor.getBoundingClientRect().top : 0,
      };
    };
    const save = () => {
      const all = read(POS_KEY) || {};
      const current = place(tapped);
      all[current.url] = current;
      const urls = Object.keys(all);
      if (urls.length > 20) delete all[urls[0]];
      write(POS_KEY, all);
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.tnr-products a[href]');
      if (!link) return;
      tapped = link;
      write(RETURN_KEY, place(link));
      save();
    });
    window.addEventListener('pagehide', save);
    // Filters swap the grid in place and change the address: save the old place first.
    document.addEventListener('click', (event) => {
      if (event.target.closest('.tnr-sizes a[href], a[data-tnr-clear], .tnr-header__category-list a[data-tnr-cat]')) save();
    }, true);

    const restoreTo = (saved) => {
      // Stop correcting as soon as the shopper scrolls themselves.
      let touched = false;
      const stop = () => (touched = true);
      ['wheel', 'touchmove', 'keydown'].forEach((type) =>
        window.addEventListener(type, stop, { once: true, passive: true })
      );
      const restore = () => {
        if (touched) return;
        const card = saved.href && cards().find((a) => a.getAttribute('href') === saved.href);
        const y = card ? card.getBoundingClientRect().top + window.scrollY - saved.top : saved.y;
        if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
      };
      // Now (after the header has narrowed the grid), then while the page settles.
      restore();
      requestAnimationFrame(restore);
      const settle = () => [100, 300, 600, 1000, 1500].forEach((ms) => setTimeout(restore, ms));
      if (document.readyState === 'complete') settle();
      else window.addEventListener('load', settle, { once: true });
    };

    const arrival = () => {
      let viaBackLink = false;
      try {
        viaBackLink = sessionStorage.getItem(BACK_FLAG) === '1';
        sessionStorage.removeItem(BACK_FLAG);
      } catch (e) {}
      const navigation = performance.getEntriesByType('navigation')[0];
      const saved = (read(POS_KEY) || {})[here()];
      tapped = null;
      if (saved && (viaBackLink || navigation?.type === 'back_forward')) restoreTo(saved);
    };
    arrival();

    // Kept in memory by the browser (instant back): check the place is still right.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      const saved = (read(POS_KEY) || {})[here()];
      tapped = null;
      if (saved) restoreTo(saved);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnr-product"]) return;
  try {
    
  (() => {
    /*
     * Photo viewer: click a product photo to open it full screen.
     * Click/tap the photo to zoom in at that spot; move the mouse (or drag a finger) to look
     * around; click again to zoom out. Arrows / swipe / ← → step through photos; X or Esc closes.
     */
    const ZOOM = 2.5;
    let box = null;
    let photos = [];
    let index = 0;
    let lastTrigger = null;
    let touchStart = null;

    const els = () => ({
      img: box.querySelector('[data-tnr-lb-img]'),
      count: box.querySelector('[data-tnr-lb-count]'),
      stage: box.querySelector('[data-tnr-lb-stage]'),
    });

    const setZoom = (on, x = 0.5, y = 0.5) => {
      const { img } = els();
      img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
      box.classList.toggle('is-zoomed', on);
      // Zoomed in, ask for a bigger file so details stay sharp; back to screen size otherwise.
      if (img.srcset) img.sizes = on ? `${Math.round(ZOOM * 100)}vw` : '100vw';
    };

    // Load (once) the screen-sized version of a photo in the background.
    const preload = (i) => {
      const button = photos[(i + photos.length) % photos.length];
      if (!button || button.tnrPreload) return button?.tnrPreload;
      const image = new Image();
      image.sizes = '100vw';
      if (button.dataset.srcset) image.srcset = button.dataset.srcset;
      image.src = button.dataset.full;
      const ready = image.decode ? image.decode().catch(() => {}) : Promise.resolve();
      button.tnrPreload = ready.then(() => image);
      return button.tnrPreload;
    };

    const show = (i) => {
      index = (i + photos.length) % photos.length;
      const shown = index;
      const button = photos[index];
      const { img, count } = els();
      setZoom(false);
      count.textContent = `${index + 1}/${photos.length}`;
      img.alt = button.dataset.alt || '';

      // 1. Straight away: the photo already on the page (no waiting).
      const onPage = button.querySelector('img');
      img.removeAttribute('srcset');
      img.src = onPage?.currentSrc || onPage?.src || button.dataset.full;

      // 2. Swap in the sharp, screen-sized version as soon as it's ready.
      preload(index).then((image) => {
        if (shown !== index || !box || box.hidden) return;
        img.sizes = box.classList.contains('is-zoomed') ? `${Math.round(ZOOM * 100)}vw` : '100vw';
        if (image.srcset) img.srcset = image.srcset;
        img.src = image.src;
      });

      // 3. Get the neighbours ready so swiping is instant.
      if (photos.length > 1) {
        preload(index + 1);
        preload(index - 1);
      }
    };

    const open = (trigger) => {
      box = document.querySelector('.tnr-lightbox');
      if (!box) return;
      photos = [...document.querySelectorAll('[data-tnr-zoom]')];
      lastTrigger = trigger;
      box.style.setProperty('--tnr-zoom', ZOOM);
      show(photos.indexOf(trigger));
      box.hidden = false;
      document.documentElement.classList.add('tnr-lightbox-open');
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        box.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
      }
      box.querySelector('[data-tnr-lb-close]').focus({ preventScroll: true });
    };

    const close = () => {
      if (!box || box.hidden) return;
      setZoom(false);
      box.hidden = true;
      document.documentElement.classList.remove('tnr-lightbox-open');
      lastTrigger?.focus({ preventScroll: true });
    };

    // Position of the pointer inside the photo, 0–1 on each axis.
    const pointIn = (event) => {
      const rect = els().img.getBoundingClientRect();
      return {
        x: Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width)),
        y: Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height)),
      };
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tnr-zoom]');
      if (trigger) {
        open(trigger);
        return;
      }
      if (!box || box.hidden) return;
      if (event.target.closest('[data-tnr-lb-close]')) close();
      else if (event.target.closest('[data-tnr-lb-prev]')) show(index - 1);
      else if (event.target.closest('[data-tnr-lb-next]')) show(index + 1);
      else if (event.target.closest('[data-tnr-lb-img]')) {
        if (touchStart?.moved) return;
        const { x, y } = pointIn(event);
        setZoom(!box.classList.contains('is-zoomed'), x, y);
      }
    });

    // Zoomed: the view follows the mouse, or the finger while it's down.
    document.addEventListener('pointermove', (event) => {
      if (!box || box.hidden || !box.classList.contains('is-zoomed')) return;
      if (event.pointerType !== 'mouse' && !touchStart) return;
      if (!event.target.closest('[data-tnr-lb-stage]')) return;
      const { x, y } = pointIn(event);
      els().img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
      if (touchStart) touchStart.moved = true;
    });

    // Touch: swipe left/right to change photo when not zoomed.
    document.addEventListener('pointerdown', (event) => {
      if (!box || box.hidden || event.pointerType === 'mouse') return;
      if (!event.target.closest('[data-tnr-lb-stage]')) return;
      touchStart = { x: event.clientX, y: event.clientY, moved: false };
    });
    document.addEventListener('pointerup', (event) => {
      if (!touchStart) return;
      const dx = event.clientX - touchStart.x;
      const dy = event.clientY - touchStart.y;
      if (!box.classList.contains('is-zoomed') && photos.length > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        touchStart.moved = true;
        show(dx < 0 ? index + 1 : index - 1);
      }
      setTimeout(() => (touchStart = null), 0);
    });

    document.addEventListener('keydown', (event) => {
      if (!box || box.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowRight' && photos.length > 1) show(index + 1);
      else if (event.key === 'ArrowLeft' && photos.length > 1) show(index - 1);
      else if (event.key === 'Tab') {
        // Keep focus inside the viewer.
        const focusable = [...box.querySelectorAll('button')];
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    /*
     * "< back" returns to the grid the shopper came from (same filters, same spot), even after
     * paging through products with "next >". The grid remembered itself when a card was tapped.
     */
    document.addEventListener('click', (event) => {
      const back = event.target.closest('[data-tnr-back]');
      if (!back) return;
      let gridUrl = '';
      let referrer = '';
      try {
        gridUrl = JSON.parse(sessionStorage.getItem('tnr-grid-return') || 'null')?.url || '';
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.origin === window.location.origin) referrer = ref.pathname + ref.search;
      } catch (e) {}
      if (!gridUrl) return;
      event.preventDefault();
      // Straight from the grid: a real "back" (the browser may keep the page as it was).
      if (referrer === gridUrl && window.history.length > 1) {
        window.history.back();
        return;
      }
      try {
        sessionStorage.setItem('tnr-grid-back', '1');
      } catch (e) {}
      window.location.href = gridUrl;
    });

    // Tabs: one panel open at a time; clicking the open one closes it.
    // Same motion as the header's "sizing" panel: the area glides to its new height and the text fades in.
    const DURATION = 240;
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const heightFrames = (a, b) => [
      { height: `${a}px`, overflow: 'hidden' },
      { height: `${b}px`, overflow: 'hidden' },
    ];

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-tnr-tab]');
      if (!tab) return;
      const group = tab.closest('[data-tnr-tabs]');
      const opening = tab.getAttribute('aria-expanded') !== 'true';
      const panelOf = (button) => document.getElementById(button.getAttribute('aria-controls'));
      const tabs = [...group.querySelectorAll('[data-tnr-tab]')];
      const panels = tabs.map(panelOf).filter(Boolean);

      panels.forEach((panel) => panel.getAnimations().forEach((a) => a.cancel()));
      group.getAnimations().forEach((a) => a.cancel());

      const from = group.offsetHeight;
      const previous = panels.find((panel) => !panel.hidden);

      tabs.forEach((other) => {
        const open = other === tab && opening;
        other.setAttribute('aria-expanded', String(open));
        const icon = other.querySelector('[data-tnr-toggle-icon]');
        if (icon) icon.textContent = open ? '[-]' : '[+]';
        const panel = panelOf(other);
        if (panel) panel.hidden = !open;
      });

      const to = group.offsetHeight;
      if (reduceMotion()) return;

      if (opening) {
        group.animate(heightFrames(from, to), { duration: DURATION, easing: 'ease-out' });
        panelOf(tab)?.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: DURATION,
          delay: previous ? DURATION / 3 : 0,
          easing: 'ease-out',
          fill: 'backwards',
        });
        return;
      }

      // Closing the open tab: keep its text visible while it fades and the area shrinks, then hide it.
      if (!previous) return;
      previous.hidden = false;
      previous.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DURATION / 2, fill: 'forwards' });
      group
        .animate(heightFrames(from, to), { duration: DURATION, easing: 'ease-in', fill: 'forwards' })
        .finished.then(() => {
          previous.hidden = true;
          previous.getAnimations().forEach((a) => a.cancel());
          group.getAnimations().forEach((a) => a.cancel());
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
